import createActionHandlers from '@sift/resift/redux/FetchUtils/createActionHandlers';
import createReducer from '@sift/resift/redux/createReducer';
import { mergeSuccess } from '@sift/resift/redux/FetchUtils';

export const COMPANY_API_IDENTIFIER = 'COMPANY_API_IDENTIFIER';

export const COMPANY_API_CLIENT_FETCH = 'COMPANY_API_CLIENT_FETCH';
export const COMPANY_API_CLIENT_FETCH_SUCCESS = 'COMPANY_API_CLIENT_FETCH_SUCCESS';
export const COMPANY_API_CLIENT_FETCH_ERROR = 'COMPANY_API_CLIENT_FETCH_ERROR';

export const COMPANY_API_CLIENT_UPDATE = 'COMPANY_API_CLIENT_UPDATE';
export const COMPANY_API_CLIENT_UPDATE_SUCCESS = 'COMPANY_API_CLIENT_UPDATE_SUCCESS';
export const COMPANY_API_CLIENT_UPDATE_ERROR = 'COMPANY_API_CLIENT_UPDATE_ERROR';

export const COMPANY_API_CLIENT_OWNERS_ADD = 'COMPANY_API_CLIENT_OWNERS_ADD';
export const COMPANY_API_CLIENT_OWNERS_ADD_SUCCESS = 'COMPANY_API_CLIENT_OWNERS_ADD_SUCCESS';
export const COMPANY_API_CLIENT_OWNERS_ADD_ERROR = 'COMPANY_API_CLIENT_OWNERS_ADD_ERROR';

export const COMPANY_API_CLIENT_OWNERS_UPDATE = 'COMPANY_API_CLIENT_OWNERS_UPDATE';
export const COMPANY_API_CLIENT_OWNERS_UPDATE_SUCCESS = 'COMPANY_API_CLIENT_OWNERS_UPDATE_SUCCESS';
export const COMPANY_API_CLIENT_OWNERS_UPDATE_ERROR = 'COMPANY_API_CLIENT_OWNERS_UPDATE_ERROR';

const mergeMutationResult = (state, action, mutationName) => {
  return {
    ...state,
    objects: {
      ...state.objects,
      [action.identifier]: {
        ...state.objects[action.identifier],
        client: state.objects[action.identifier][mutationName],
      },
    },
  };
};

export const fetchCompanyApiClient = () => {
  return {
    type: COMPANY_API_CLIENT_FETCH,
    identifier: COMPANY_API_IDENTIFIER,
    payload: {},
  };
};

export const updateCompanyApiClient = client => {
  return {
    type: COMPANY_API_CLIENT_UPDATE,
    identifier: COMPANY_API_IDENTIFIER,
    payload: { client },
  };
};

export const addOwnersToCompanyApiClient = ownerIds => {
  return {
    type: COMPANY_API_CLIENT_OWNERS_ADD,
    identifier: COMPANY_API_IDENTIFIER,
    payload: { ownerIds },
  };
};

export const updateCompanyAPIOwners = ownerIds => {
  return {
    type: COMPANY_API_CLIENT_OWNERS_UPDATE,
    identifier: COMPANY_API_IDENTIFIER,
    payload: { ownerIds },
  };
};

const DATA_SERVICE_ACTION_HANDLERS = {
  ...createActionHandlers(COMPANY_API_CLIENT_FETCH),
  ...createActionHandlers(COMPANY_API_CLIENT_UPDATE),
  ...createActionHandlers(COMPANY_API_CLIENT_OWNERS_UPDATE),
  [COMPANY_API_CLIENT_UPDATE_SUCCESS]: (state, action) => {
    const newState = mergeSuccess(state, action);
    const updatedState = mergeMutationResult(newState, action, 'updateClient');
    return updatedState;
  },
  [COMPANY_API_CLIENT_OWNERS_UPDATE_SUCCESS]: (state, action) => {
    const newState = mergeSuccess(state, action);
    const updatedState = mergeMutationResult(newState, action, 'updateClient');
    return updatedState;
  },
};

const initialState = {
  objects: {},
  fetches: {},
};
export default createReducer(initialState, DATA_SERVICE_ACTION_HANDLERS);
